
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/topup",
      function () {
        return require("private-next-pages/en/topup/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/topup"])
      });
    }
  